/* ============================================================
   BEYTIK — product-page-scripts.js
   Add to Assets, then in main-product.liquid before </product-info>:
   <script src="{{ 'product-page-scripts.js' | asset_url }}" defer></script>
   ============================================================ */
(function () {
  'use strict';

  function initReadMore() {
    document.querySelectorAll('.product__description.rte').forEach(function (desc) {
      if (desc.dataset.ppInit) return;
      desc.dataset.ppInit = '1';
      if (desc.scrollHeight <= 150) return;
      var wrap = document.createElement('div');
      wrap.className = 'pp-desc-wrap';
      while (desc.firstChild) wrap.appendChild(desc.firstChild);
      desc.appendChild(wrap);
      var btn = document.createElement('button');
      btn.type = 'button';s
      btn.className = 'pp-read-more';
      btn.setAttribute('aria-expanded', 'false');
      btn.innerHTML = '<span class="pp-label">Read more</span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="14" height="14"><polyline points="6 9 12 15 18 9"/></svg>';
      desc.appendChild(btn);
      btn.addEventListener('click', function () {
        var open = wrap.classList.toggle('pp-expanded');
        btn.classList.toggle('pp-open', open);
        btn.setAttribute('aria-expanded', String(open));
        btn.querySelector('.pp-label').textContent = open ? 'Show less' : 'Read more';
      });
    });
  }

  function run() { initReadMore(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    setTimeout(run, 0);
  }
  document.addEventListener('shopify:section:load', run);
})();
